module.exports = __webpack_public_path__ + "static/peelSeal-df9bf6b63e289a6a0bfa4797a23aa476.gif";